import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import {
	ContentMain,
	Page,
	ScreenView,
	SubPageMain,
	Apresentation,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	SelectOrder,
	DefaultButton,
	Error,
} from "../../style/default";
import { customStyles } from "../../style/selectStyles";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { authApi } from "../../services/api";
import { Skeleton } from "../../components/Skeleton/table";
import Tooltip from "../../components/Tooltip";
import { AiOutlineClose, AiOutlineCheck } from "react-icons/ai";
import MyTooltip from "../../components/Tooltip";
import ConfigureLabel from "../../helpers/configureLabel";
import { BiMessageSquareEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { ModalContext } from "../../context/modal";
import { ModalCheckTemplateEdit } from "./modal-edit";
import { MyHorizontalScrollView, ShowReject } from "./styles";
import { ModalDeleteTemplate } from "./modal-delete";
import { debounce } from "../../utils/debounce";

const templateColumns = [
	"Cliente",
	"Nome",
	"Element name",
	"Erro 360",
	"Criado via API",
	"Conteúdo",
	"respostas rápidas",
	"status",
	"data de criação",
	"ações",
];

function CheckTemplates() {
	const [isLoading, setIsLoading] = useState(false);
	const [template, setTemplate] = useState([]);
	const [filteredTemplates, setFilteredTemplates] = useState([...template]);
	const [searchQuery, setSearchQuery] = useState("");
	const [selectAccounts, setSelectAccounts] = useState([]);
	const [modalEdit, setModalEdit] = useState(false);
	const [modalReject, setModalReject] = useState(false);
	const [modalData, setModalData] = useState({});
	const { open, handleOpenModal } = useContext(ModalContext);
	const [showRejected, setShowRejected] = useState(false);
	const [selectedAccount, setSelectedAccount] = useState({
		label: "Todos",
		value: "",
	});
	const [selectedStatus, setSelectedStatus] = useState({
		label: "Pendente",
		value: "pending",
	});

	const handleModalEdit = () => {
		setModalReject(false);
		setModalEdit(true);
		handleOpenModal();
	};

	const handleModalReject = () => {
		setModalEdit(false);
		setModalReject(true);
		handleOpenModal();
	};

	const handleTemplate = async (client, status) => {
		try {
			setIsLoading(true);
			const { data } = await authApi.post("/template", {
				account: client,
				status: status,
				showRejected: showRejected,
			});
			setTemplate(data);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			toast.error(error.message, TOASTIFY_OPTIONS);
		}
	};

	const handleSelectAccounts = async () => {
		try {
			const { data } = await authApi.get("/account/all/select");
			const seriData = [];
			seriData.push({ label: "Todos", value: "" });
			for (let i = 0; i < data.length; i++) {
				seriData.push({ label: data[i].name, value: data[i]._id });
			}
			setSelectAccounts(seriData);
		} catch (error) {
			console.log("Erro ao popular select");
		}
	};

	const handleApproveTemplate = async (item) => {
		try {
			const confirm = window.confirm(
				`Deseja realmente aprovar o template: ${item.name}?`
			);
			if (!confirm) {
				return;
			}
			const approveTemplate = await authApi.post("/template/approve", {
				template: item._id,
			});
			if (approveTemplate.status === 200) {
				toast.success("Template aprovado com sucesso!", TOASTIFY_OPTIONS);
				handleTemplate(selectedAccount.value, selectedStatus.value);
			}
		} catch (error) {
			toast.error("Não foi possível aprovar o template", TOASTIFY_OPTIONS);
		}
	};

	const handleRejectTemplate = async (item) => {
		try {
			const confirm = window.confirm(
				`Deseja realmente rejeitar o template: ${item.name}?`
			);
			if (!confirm) {
				return;
			}
			const approveTemplate = await authApi.post("/template/reject", {
				template: item._id,
			});
			if (approveTemplate.status === 200) {
				toast.success("Template rejeitado com sucesso!", TOASTIFY_OPTIONS);
				handleTemplate(selectedAccount.value, selectedStatus.value);
			}
		} catch (error) {
			toast.error("Não foi possível rejeitar o template", TOASTIFY_OPTIONS);
		}
	};

	useEffect(() => {
		handleSelectAccounts();
		handleTemplate(selectedAccount.value, selectedStatus.value);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (selectedStatus.value.length) {
			if (selectedStatus.value !== "all") {
				setShowRejected(false);
			}
		}
		handleTemplate(selectedAccount.value, selectedStatus.value);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedStatus.value, showRejected]);

	const handleRegisterByAPI = (text) => (text ? "Sim" : "Não");

	useEffect(() => {
		const filtered = template.filter(
			(template) =>
				template.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
				template.gupshupElementName
					.toLowerCase()
					.includes(searchQuery.toLowerCase())
		);
		setFilteredTemplates(filtered);
	}, [searchQuery, template]);

	const handleSearch = (event) => {
		const query = event.target.value;
		setSearchQuery(query);
	};

	return (
		<Page>
			{/*Modals below*/}
			{open && modalEdit && (
				<ModalCheckTemplateEdit
					open={open}
					data={modalData}
					selectedAccount={selectedAccount}
					selectedStatus={selectedStatus}
					populateTable={handleTemplate}
				/>
			)}
			{open && modalReject && (
				<ModalDeleteTemplate
					open={open}
					data={modalData}
					selectedAccount={selectedAccount}
					selectedStatus={selectedStatus}
					populateTable={handleTemplate}
				/>
			)}
			<Sidebar activeMenu="checkTemplate" />
			<ScreenView>
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>Validação de templates</span>
						</Apresentation>
						<SelectOrder>
							<MyHorizontalScrollView>
								<input
									type="text"
									placeholder="Filtre pelo nome interno ou nome"
									onChange={debounce(handleSearch, 1000)}
								/>
							</MyHorizontalScrollView>
							<Select
								styles={customStyles}
								placeholder="Filtrar por cliente"
								options={selectAccounts}
								onChange={(e) => {
									setSelectedAccount(e);
									handleTemplate(e.value, selectedStatus.value);
								}}
								value={selectedAccount.label && selectedAccount}
								noOptionsMessage={() => "Está Vazio!"}
							/>
							<Select
								styles={customStyles}
								placeholder="Filtrar por status"
								options={[
									{
										label: "Todos",
										value: "all",
									},
									{ label: "Pendente", value: "pending" },
									{ label: "Aprovado", value: "approved" },
									{ label: "Divergente", value: "divergent" },
									{ label: "Rejeitado", value: "rejected" },
								]}
								onChange={(e) => {
									setSelectedStatus(e);
									handleTemplate(selectedAccount.value, e.value);
								}}
								value={selectedStatus.label && selectedStatus}
								noOptionsMessage={() => "Está Vazio!"}
							/>
							{selectedStatus.value === "all" && (
								<ShowReject>
									<label htmlFor="checkStatus">Exibir rejeitados</label>
									<input
										id="checkStatus"
										type="checkbox"
										value={showRejected}
										onChange={(e) => {
											setShowRejected(e.target.checked);
										}}
									/>
								</ShowReject>
							)}
						</SelectOrder>

						{/* For Create Table need to put the finger. */}

						{isLoading ? (
							<Skeleton data={templateColumns} />
						) : template.length ? (
							<MyTable responsive>
								<MyTableHead>
									<MyTableTR>
										{templateColumns.map((column) => (
											<th key={column}>{column}</th>
										))}
									</MyTableTR>
								</MyTableHead>
								<MyTableBody>
									{filteredTemplates.map((item) => (
										<MyTableTR key={item._id}>
											<td>
												<ConfigureLabel label={item?.company} />
											</td>
											<td>
												<MyTooltip label={item?.name}>
													<button
														style={{
															cursor: "default",
															color: "#000000",
															fontWeight: 300,
														}}
													>
														<ConfigureLabel label={item?.name} />
													</button>
												</MyTooltip>
											</td>
											<td>
												<MyTooltip label={item?.gupshupElementName}>
													<button
														style={{
															cursor: "default",
															color: "#000000",
															fontWeight: 300,
														}}
													>
														<ConfigureLabel
															label={
																item?.gupshupElementName
																	? item?.gupshupElementName
																	: "-"
															}
														/>
													</button>
												</MyTooltip>
											</td>
											<td
												style={{
													maxWidth: "200px",
													overflow: "hidden",
													textOverflow: "ellipsis",
													whiteSpace: "nowrap",
												}}
											>
												{item?.error360 ? (
													<MyTooltip label={item?.error360}>
														<button
															style={{
																cursor: "default",
																color: "#000000",
																fontWeight: 300,
															}}
														>
															<ConfigureLabel label={item?.error360} />
														</button>
													</MyTooltip>
												) : (
													"-"
												)}
											</td>
											<td>
												{typeof item?.registerByAPI == "boolean"
													? handleRegisterByAPI(item?.registerByAPI)
													: item?.registerByAPI}
											</td>

											<td>
												<MyTooltip label={item?.content}>
													<button
														style={{
															cursor: "default",
															color: "#000000",
															fontWeight: 300,
														}}
													>
														<ConfigureLabel label={item?.content} />
													</button>
												</MyTooltip>
											</td>
											<td>
												<MyTooltip
													label={
														item?.quickyReplies.length
															? item?.quickyReplies
																	.map(({ value }) => value)
																	.join(", ")
															: "-"
													}
												>
													<button
														style={{
															cursor: "default",
															color: "#000000",
															fontWeight: 300,
														}}
													>
														<ConfigureLabel
															label={
																item.quickyReplies?.length
																	? item?.quickyReplies
																			.map(({ value }) => value)
																			.join(", ")
																	: "-"
															}
														/>
													</button>
												</MyTooltip>
											</td>

											<td>{<ConfigureLabel label={item?.status} />}</td>
											<td>
												{new Date(item.createdAt).toLocaleDateString("pt-BR")}
											</td>
											<td style={{ display: "flex", justifyContent: "center" }}>
												<MyTooltip label={"Editar : " + item?.name}>
													<DefaultButton
														onClick={() => {
															setModalData(item);
															handleModalEdit();
														}}
													>
														<BiMessageSquareEdit size={20} />
													</DefaultButton>
												</MyTooltip>

												{item.status === "pending" ? (
													<>
														<Tooltip label={"Aprovar"}>
															<DefaultButton
																onClick={() => handleApproveTemplate(item)}
															>
																<AiOutlineCheck />
															</DefaultButton>
														</Tooltip>
														<Tooltip label={"Rejeitar"}>
															<DefaultButton
																onClick={() => handleRejectTemplate(item)}
															>
																<AiOutlineClose />
															</DefaultButton>
														</Tooltip>
													</>
												) : null}
												<MyTooltip
													label={"Rejeitar e desativar: " + item?.name}
												>
													<DefaultButton
														onClick={() => {
															setModalData(item);
															handleModalReject();
														}}
													>
														<AiFillDelete size={20} />
													</DefaultButton>
												</MyTooltip>
											</td>
										</MyTableTR>
									))}
								</MyTableBody>
							</MyTable>
						) : (
							<Error>Nenhum dado encontrado</Error>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
}

export default CheckTemplates;
